// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__UQrpe","content":"styles_content__1hruO","time":"styles_time__-FG0A"};